module.exports = __webpack_public_path__ + "static/assets/c5bfa66050ac9cabdcacc7f9b763bc5d.svg";